/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCertificate = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.25 15.84H16.04v4h15.21v-4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 32.51a12.15 12.15 0 0 0-10-11.94V9.76l-2-2H9.8l-2 2V53.7l2 2h26V58l3.47 1.36 6.53-7.06 6.53 7.06 3.5-1.36V39.39A12.07 12.07 0 0 0 58 32.51Zm-4 0a8.15 8.15 0 1 1-8.15-8.15A8.16 8.16 0 0 1 54 32.51ZM11.8 51.7V11.76H44v8.76A12.14 12.14 0 0 0 37.18 24H16.1v4h18.46a12.1 12.1 0 0 0-.85 4H16.1v4h18.1a12.186 12.186 0 0 0 1.63 3.41V51.7H11.8ZM47.29 48l-1.46-1.58L44.37 48l-4.54 4.9v-9.84a12.05 12.05 0 0 0 12 0v9.83L47.29 48Z"
}));

export default SvgCertificate;